import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Button, TextField
} from '@material-ui/core';
import CurrencyTextField from '@unicef/material-ui-currency-textfield'

const MemoDialog = ({ open, memo, onClose, onSave }) => {

  const [ adjust, setAdjust ] = useState("0");
  const [ adjustMemo, setAdjustMemo ] = useState("");

  const handleEnter = () => {
    // CurrencyTextField 는 ',' 받지 않음 
    setAdjust(memo.adjust.replaceAll(',', ''));
    setAdjustMemo(memo.adjustMemo);
  }

  const handleChangeAdjust = (evt, value) => {
    setAdjust(value);
  }

  const handleChangeAdjustMemo = evt => {
    setAdjustMemo(evt.target.value);
  }

  const handleClickSave = () => {
    // onClose();
    onSave({
      adjust: adjust.replace(/\B(?=(\d{3})+(?!\d))/g, ","),     // ',' 추가 
      adjustMemo
    });
  }

  return (
    <Dialog
      open={open}
      onEnter={handleEnter}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle
        id="form-dialog-title"
      >
        메모 수정
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignContent="center"
        >
          <Box>
            <TextField
              id="adjust-memo"
              label="Memo"
              value={adjustMemo}
              onChange={handleChangeAdjustMemo}
              variant="outlined"
              multiline
              rows={4}
              shrink
            />
          </Box>
          <Box
            mt="10px"
          >
            <CurrencyTextField
              id="adjust"
              label="Adjust"
              value={adjust}
              onChange={handleChangeAdjust}
              variant="outlined"
              currencySymbol="￦"
              outputFormat="string"
              digitGroupSeparator=","
              decimalPlaces="0"
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleClickSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MemoDialog;